<template>
  <div class="claimDetail">
    <div class="loading" id="loading" v-show="loading"><div class="circle"></div></div>
    <div class="main claim">
        <div class="title">
            <p class="zhongan">WiFi安全险<img src="../images/zhongan.png" alt=""></p>
            <p class="status" v-if="obj.status == 1">&nbsp;</p>
            <p class="status_success" v-if="obj.status == 2">&nbsp;</p>
            <p class="status_failed" v-if="obj.status == 3">&nbsp;</p>
            <div class="logo" v-if="obj.status == 1"></div>
            <div class="logo_success" v-if="obj.status == 2"></div>
            <div class="logo_failed" v-if="obj.status == 3"></div>
        </div>
    </div>
    <div id="claimPage" v-if="obj.status == 1">
        <!-- 受理中 begin-->
        <p class="limit">参保用户赔偿额度</p>
        <div class="block clearfix">
            <p class="bb">每一用户单日/单次索赔限额：<span>￥20,000元</span></p>
            <p>每一用户累计最高可赔：<span>￥100,000元</span></p>
        </div>
        <div class="block clearfix">
            <p class="bb">索赔流程:<router-link to="/claimFlow">查看详情</router-link></p>
            <p class="bb">索赔资料:<router-link to="/docs">查看详情</router-link></p>
            <p>服务热线:<a href="tel:4009999595">400-999-9595</a></p>
        </div>
        <div class="block clearfix">
            <p class="bb">索赔资料收件人:<span class="small_font">WiFi万能钥匙用户安全理赔项目组</span></p>
            <p class="bb">寄送地址:<span class="small_font">上海市浦东新区张衡路666弄1号楼7楼</span></p>
            <p>快递联系电话:<span>400-035-8000</span></p>
        </div>
        <!-- 受理中 end-->
    </div>
    <div id="claimSuccessPage" v-if="obj.status == 2">
        <!-- 受理成功 begin-->
        <div class="block clearfix">
            <p class="bb">索赔人:<span id="username">{{obj.u_name}}</span></p>
            <p class="bb">索赔金额:<span id="price">￥{{obj.price}}</span></p>
            <p>银行卡号:<span id="bankCard">{{obj.bank_card}}</span></p>
        </div>
        <div class="block clearfix">
            <p class="bb">索赔开始时间:<span id="startDate">{{obj.start_ts}}</span></p>
            <p>索赔结束时间:<span id="endDate">{{obj.end_ts}}</span></p>
        </div>
        <div class="block clearfix">
            <p id="reason"><span style="position: static;">备注:{{obj.reason}}</span></p>
        </div>
        <!-- 受理成功 end-->
    </div>
    <div id="claimFailedPage" v-if="obj.status == 3">
        <!-- 受理失败 begin-->
        <div class="block clearfix">
            <p>索赔人:<span id="username">{{obj.u_name}}</span></p>
        </div>
        <div class="block clearfix">
            <p class="bb">索赔开始时间:<span id="startDate">{{obj.start_ts}}</span></p>
            <p>索赔结束时间:<span id="endDate">{{obj.end_ts}}</span></p>
        </div>
        <div class="block clearfix">
            <p id="reason"><span style="position: static;">备注:{{obj.reason}}</span></p>
        </div>
        <!-- 受理失败 end-->
    </div>
  </div>
</template>

<script>
const AES = require('@/lib/Utils/AES').default
export default {
  name: 'claimDetail',
  mounted:function(){
      var _self = this;
      var orderId = this.$route.query.order_id,
            uhid    = this.$route.query.uhid;

      _self.loading = true;

      let data = {
        "id":orderId,
        "uhid":uhid
      }
      let ed = AES.Encrypt( JSON.stringify(data), AES.obj())

      this.$http.post(_host + '/safe/get_one',{
          ed: ed
        },{
            emulateJSON: true
        }).then(function(response){
            _self.loading = false;
            var json = response.body;
            if(json.c=='0000'){
                _self.obj = json.m;
                console.log(_self.obj);
            }else{
                safe.model({
                    title:'温馨提示',
                    content:json.m,
                    foot:'我知道了'
                });
                safe.bindModelEvent();
            }
        })
        _self.$trace.enterTraceDone({page: 3})
  },
  data () {
    return {
        obj:'',
        loading:false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body{background-color: #f3f3f3;height: 100%;padding-bottom: 50px;}
p{line-height: 45px;font-size: 14px;}
.small_font{font-size: 12px;}
.claimDetail{padding-top: 15px;}
.main{display: block; position: relative;color: #666666;margin-top: 0;padding-bottom: 0; }
.title{background-color: #ffffff;padding: 0 6%;border-top:6px solid #6ab8f8;}
.title .status{font-size: 14px;width: 50%;border-top: 1px solid #f2f2f2;font-weight: normal;}
.title p{padding: 0}
.title .zhongan{font-size: 18px;color: #0285f0;}
.title .zhongan img{width: 24%;position: absolute;right: 3%;top: 17px}
.title .logo{
    position: absolute;
    right: 6%;
    top: 21px;
    width: 60px;
    height: 60px;
    background-repeat: no-repeat;
    background-size: 100%;
}
.limit,.block p{padding-left: 6%;}

.block{background-color: #ffffff;position: relative;margin-bottom: 15px;}
.block span,.block a{position: absolute; right: 6%}
.block a{color: #0285f0;}
.block p{color: #666666;}

.bottom_btn{
    text-align: center;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    color: #0285f0;
    background-color: #ffffff;
    line-height: 50px;
    text-decoration: none;
    border-top: #dbdbdb solid 1px;
    bottom: 0;
}
.foot{position: fixed;}
.claimList{
    box-sizing:border-box;
    -moz-box-sizing:border-box;
    -webkit-box-sizing:border-box;
    border-left: #dbdbdb solid 1px;
}
.claim .title .status{color: #F55E52;}
.claim .title .logo{background-image: url(../images/claim.png);}

.claim .title .status_success{color: #0285f0;}
.claim .title .logo_success{background-image: url(../images/claim_success.png);}

.claim .title .status_failed{color: #666666;}
.claim .title .logo_failed{background-image: url(../images/claim_failed.png);}
</style>



// WEBPACK FOOTER //
// claimDetail.vue?2e59ce57